import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FacebookShareButton, TwitterShareButton } from 'react-share';
import { Button } from 'reactstrap';

class ShareButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sharevideo: '',
    }
  }

  toggleshare = () => {
    if (this.state.sharevideo === '') {
      this.setState({ sharevideo: 'menu-active' });
    } else {
      this.setState({ sharevideo: '' });
      this.props.toggle();
    }
  }

  componentDidMount(){
    if(this.props.view){
      this.setState({sharevideo: 'menu-active'})
    }
  }

  componentDidUpdate(prevProps, prevState){
    if(this.props.view && !prevProps.view){
      this.setState({sharevideo: 'menu-active'})
    }
  }

  onCopy = () => {
    this.setState({ copied: true, btn_copy: 'clicked-copy' });
  }

  render() {
    return <>
    <div className={['share-video', this.state.sharevideo].join(' ')}>
      <div className="menu">
        <div className="menu-all">
          <div className="menu-top">
            <ul>
              <li><button className="btn btn-menu-close" 
              onClick={this.toggleshare}><img src="http://resources.triyakom.com/mini_portal/close.svg" /></button></li>
            </ul>
          </div>
          <div className="share-video-inner">
            <div className="share-text">SHARE TO FRIEND</div>
            <div className="menu-bottom">
              <ul>
                <li>
                  <FacebookShareButton url={this.props.shareUrl} quote={this.props.title}>
                    <Button color="none">
                      <span>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40.018 40.018">
                          <path className="a" d="M35.015,0H5A5.007,5.007,0,0,0,0,5V35.015a5.007,5.007,0,0,0,5,5H35.015a5.007,5.007,0,0,0,5-5V5A5.007,5.007,0,0,0,35.015,0Z" />
                          <path className="b" d="M210.758,108.505h-6.253v-5c0-1.381,1.12-1.251,2.5-1.251h2.5V96h-5a7.5,7.5,0,0,0-7.5,7.5v5h-5v6.253h5v13.756h7.5V114.758h3.752Z" transform="translate(-176.993 -88.497)" />
                        </svg>
                      </span>
                      <span>FACEBOOK</span>
                    </Button>
                  </FacebookShareButton>
                </li>
                <li>
                  <TwitterShareButton url={this.props.shareUrl} quote={this.props.title}>
                    <Button color="none">
                      <span>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40.018 40.018">
                          <g>
                            <path className="a" d="M35.015,0H5A5.007,5.007,0,0,0,0,5V35.015a5.007,5.007,0,0,0,5,5H35.015a5.007,5.007,0,0,0,5-5V5A5.007,5.007,0,0,0,35.015,0Z" />
                          </g>
                          <path className="b" d="M24.73,50.379a10.57,10.57,0,0,1-2.921.8,5.041,5.041,0,0,0,2.23-2.8A10.132,10.132,0,0,1,20.825,49.6a5.07,5.07,0,0,0-8.77,3.467,5.22,5.22,0,0,0,.117,1.156,14.351,14.351,0,0,1-10.45-5.3A5.071,5.071,0,0,0,3.28,55.7a5.007,5.007,0,0,1-2.291-.624v.056a5.093,5.093,0,0,0,4.062,4.982,5.06,5.06,0,0,1-1.329.167,4.483,4.483,0,0,1-.96-.087A5.118,5.118,0,0,0,7.5,63.725a10.187,10.187,0,0,1-6.286,2.162A9.5,9.5,0,0,1,0,65.818a14.273,14.273,0,0,0,7.778,2.275,14.331,14.331,0,0,0,14.43-14.427c0-.224-.008-.441-.019-.655A10.114,10.114,0,0,0,24.73,50.379Z" transform="translate(9.195 -38.274)" />
                        </svg>
                      </span>
                      <span>TWITTER</span>
                    </Button>
                  </TwitterShareButton>
                </li>
                <li style={{ marginTop: "1.05em" }}>
                  <CopyToClipboard onCopy={this.onCopy} text={this.props.shareUrl}>
                    <Button color="none" className={this.state.btn_copy}>
                      <span>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40.018 40.018">
                          <g transform="translate(0 0)">
                            <path className="a" d="M35.015,0H5A5.007,5.007,0,0,0,0,5V35.015a5.007,5.007,0,0,0,5,5H35.015a5.007,5.007,0,0,0,5-5V5A5.007,5.007,0,0,0,35.015,0Z" transform="translate(0 0)" />
                          </g>
                          <g transform="translate(10.071 10.071)">
                            <path className="b" d="M13.727,185.881a4.558,4.558,0,0,0-.014-.98,4.416,4.416,0,0,0-.293-1.128q-.027-.067-.057-.133a4.44,4.44,0,0,0-.918-1.331l-.017-.017a4.479,4.479,0,0,0-.845-.656l-1.395,1.38a.89.89,0,0,0-.249.452,2.093,2.093,0,0,1,.829.5l.008.008a2.094,2.094,0,0,1-.008,2.965l-4.757,4.707a2.191,2.191,0,0,1-3.034,0l-.008-.008a2.094,2.094,0,0,1,.008-2.965L5.7,185.984a5.616,5.616,0,0,1-.5-2.32q0-.268.025-.531L1.319,187a4.452,4.452,0,0,0-.017,6.309l.017.017a4.531,4.531,0,0,0,6.352,0l4.757-4.707a4.411,4.411,0,0,0,1.3-2.71Z" transform="translate(0 -174.495)" />
                            <path className="b" d="M163.64,12.331a4.481,4.481,0,0,0,.845.656l1.395-1.38a.889.889,0,0,0,.249-.452,2.093,2.093,0,0,1-.829-.5l-.008-.008a2.094,2.094,0,0,1,.008-2.965l4.757-4.707a2.191,2.191,0,0,1,3.034,0l.006.006a2.094,2.094,0,0,1-.006,2.967L170.37,8.64a5.617,5.617,0,0,1,.5,2.32q0,.268-.025.531l3.908-3.866a4.452,4.452,0,0,0,.017-6.309l-.017-.017a4.531,4.531,0,0,0-6.352,0L163.64,6.006a4.452,4.452,0,0,0-.017,6.309l.017.017Z" transform="translate(-155.939 0.001)" />
                          </g>
                        </svg>
                      </span>
                      <span>COPY LINK</span>
                    </Button>
                  </CopyToClipboard>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
  }
}

export default ShareButton;